import axios from 'axios';
import { PlanningPrognosisSite } from '../types/planning-prognosis-site.type';

// GET
// /ewosapi/v2/planandprognosis/company/{globalCompanyId}/site
export const getPlanAndPrognosisSites = async (globalCompanyId: string): Promise<PlanningPrognosisSite[]> => {
  const res = await axios.get<PlanningPrognosisSite[]>(`/ewosapi/v2/planandprognosis/company/${globalCompanyId}/site`);
  return res.data;
};
